/**
 * «Отметка о просмотре».
 *
 * Цвет сотрудник выбирает сам — палитрой или пипеткой. Пока свой не выбран,
 * карточки закрашиваются пастельным жёлтым: насыщенный фон по умолчанию
 * спорил бы с тегами, приоритетом и красным сроком.
 */

/** Цвет, которым включается режим, пока другой не выбран. */
export const DEFAULT_VIEW_MARK_COLOR = "#FDE68A";
